<template>
	<b-card no-body>
		<b-card-header>
			<h5 class="mb-0 text-white">
				<b>FILTROS</b>
			</h5>
		</b-card-header>
		<b-card-body class="pt-2">
			<b-row>
				<b-col
					cols="12"
					md="4"
					class="mb-2"
				>
					<label for="businessAreas">
						<strong>RUBRO(S)</strong>
					</label>
					<v-select
						id="businessAreas"
						:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
						placeholder="Seleccione"
						multiple
						v-model="formData.businessAreasArray"
						:options="options.businessAreas"
						class="w-100"
						@input="inputBusinessAreasVal()"
					/>
				</b-col>

				<b-col
					cols="12"
					md="4"
					class="mb-2"
				>
					<label for="performanceGroup">
						<strong>GRUPO DE EVALUACIÓN</strong>
					</label>
					<v-select
						id="performanceGroup"
						:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
						placeholder="Seleccione"
						multiple
						v-model="formData.performanceGroupsArray"
						:options="options.performanceGroups"
						class="w-100"
						@input="inputPerformanceGroupsVal()"
					/>
				</b-col>

				<b-col
					cols="12"
					md="4"
					class="mb-2"
				>
					<label for="approvalStates">
						<strong>ESTADO(S) DE HOMOLOGACIÓN</strong>
					</label>
					<v-select
						id="approvalStates"
						:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
						placeholder="Seleccione"
						multiple
						v-model="formData.approvalStatesArray"
						:options="options.approvalStates"
						class="w-100"
						@input="inputApprovalStatesVal()"
					/>
				</b-col>
			</b-row>
		</b-card-body>
	</b-card>
</template>

<script>
import { ref } from "@vue/composition-api"
import vSelect from "vue-select"

export default {
	components: {
		vSelect
	},
	props: {
		options: {
			type: Object,
			required: true
		}
	},
	setup(props, { emit }) {
		// REFS
		const formData = ref({
			businessAreasArray: [],
			approvalStatesArray: [],
			performanceGroupsArray: []
		})

		const inputBusinessAreasVal = () => {
			if (formData.value.businessAreasArray) {
				const array = formData.value.businessAreasArray.map(
					(item) => item.value
				)
				emit("update:businessAreasFilter", array.join(","))

				return array
			}

			return null
		}

		const inputPerformanceGroupsVal = () => {
			if (formData.value.performanceGroupsArray) {
				const array = formData.value.performanceGroupsArray.map(
					(item) => item.value
				)
				emit("update:performanceGroupsFilter", array.join(","))

				return array
			}

			return null
		}

		const inputApprovalStatesVal = () => {
			if (formData.value.approvalStatesArray) {
				const array = formData.value.approvalStatesArray.map(
					(item) => item.value
				)
				emit("update:approvalStatesFilter", array.join(","))

				return array
			}

			return null
		}

		return {
			// DATA
			formData,

			// METHODS
			inputBusinessAreasVal,
			inputApprovalStatesVal,
			inputPerformanceGroupsVal
		}
	}
}
</script>

<style lang="scss" scoped>
.card-header {
	background-color: var(--primary);
	padding: 1rem 1.5rem;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>